function swellLoaded(callback) {
  if (swellReady()) {
    callback();
  } else {
    let maxRetries = 10;
    let retryCount = 1;
    let retrySwellAPI = setInterval(() => {
      // console.log("Checking on swell...")
      if (swellReady() || retryCount >= maxRetries) {
        clearInterval(retrySwellAPI);
        callback();
      }
      retryCount++;
    }, 500);
  }
}

function swellReady() {
  if ('swellAPI' in window) {
    try {
      let customerInfo = window.swellAPI.getCustomerDetails();

      if (!customerInfo?.email && !window.shopifyCustomer) {
        return true;
      } else {
        if (customerInfo?.isMember !== undefined) {
          return true;
        }
      }
    } catch (e) { }
  }
  return false;
}

class Rewards {
  constructor() {
    this.swellInit = false;
    this.init();
  }

  init() {
    document
      .querySelectorAll("[data-swell-hide],[data-swell-if-field]")
      .forEach((element) => {
        element.classList.add("swell-loading");
      });

    // Recommended document.addEventListener("swell:setup"() => {}) is not reliable
    // because other third parties like CrazyRocket load jQuery which causes Yotpo
    // to fire jQuery events instead
    const boundCallback = this.populateSwellRewards.bind(this);
    swellLoaded(boundCallback);
  }

  populateSwellRewards() {
    if (!('swellAPI' in window) || this.swellInit) {
      return false;
    }

    this.swellInit = true;
    const self = this;
    const strings = window.theme.strings.rewards;
    const tierNames = {
      'General Admission': strings.tiers.generalAdmission,
      'Front Row': strings.tiers.frontRow,
      'VIP': strings.tiers.vip,
      'Backstage Pass': strings.tiers.backstagePass
    };
    const dateFormat = new Intl.DateTimeFormat(window.theme.locale || undefined, { month: 'short', day: 'numeric', year: 'numeric' });
    const formatDate = (date) => dateFormat.format(moment(date).toDate());


    let customerInfoOverride = window.localStorage.getItem('swellCustomerData') || false;

    if (customerInfoOverride) {
      try {
        customerInfoOverride = JSON.parse(customerInfoOverride)
      } catch (e) {
        console.warn('parse problem')
      }
    }


    let customerInfo = customerInfoOverride ? customerInfoOverride : window.swellAPI.getCustomerDetails();
    let swellTiers = window.swellAPI.getVipTiers().sort((a, b) => a.rank - b.rank);

    // console.log('swellTiers', swellTiers);

    if (customerInfo.optedInAt) {
      let optedInAt = moment(customerInfo.optedInAt);
      customerInfo.optedInAtDateString = formatDate(optedInAt);
    }

    if (customerInfo.vipTier && customerInfo.vipTier.vipTierSubscriptionDate) {
      // Set the date that the points expire. 1 Year from the date the current tier was reached
      let expirationDate = moment(customerInfo.vipTier.vipTierSubscriptionDate)
      customerInfo.vipTier.subscriptionDateString = formatDate(expirationDate)
      expirationDate.add(1, 'years').subtract(1, 'days')
      customerInfo.vipTier.byDateString = formatDate(expirationDate)
    }

    try {
      // Figure out the next tier
      let nextTier = null;

      if (customerInfo.vipTierStats) {
        nextTier = swellTiers.find(tier => {
          return tier.swellrequiredPointsEarned > customerInfo.vipTierStats.pointsEarned;
        });
      }

      if (nextTier) {
        customerInfo.nextTier = nextTier;
        let requiredPoints = nextTier.swellrequiredPointsEarned - customerInfo.vipTierStats.pointsEarned;

        customerInfo.nextTier.spend = window.Shopify.formatMoney(
          requiredPoints * 100,
          window.theme.moneyFormat
        );
        customerInfo.nextTier.earn = requiredPoints;
      }
    } catch (error) {
      console.log('No next VIP Tier Stats', error);
    }

    let currentTierIndex = false;
    let nextTierIndex = false;

    try {
      let vipTierId = customerInfo.vipTier ? customerInfo.vipTier.id : null;

      switch (vipTierId) {
        case swellTiers[0].id:
          currentTierIndex = 1;
          nextTierIndex = 2;
          document.querySelectorAll('[data-rewards-tier-list-item="1"]').forEach(el => el.classList.add('active'));
          document.querySelectorAll('[data-rewards-perks-tier-display]').forEach(el => {
            const tiers = el.getAttribute('data-rewards-perks-tier-display');
            if (tiers.includes('general-admission')) el.classList.add('active')
          });
          document.querySelectorAll('[data-rewards-tier-list-message="1"]').forEach(el => el.innerHTML = strings.currentTier);
          break;
        case swellTiers[1].id:
          currentTierIndex = 2;
          nextTierIndex = 3;
          document.querySelectorAll('[data-rewards-tier-list-item="1"], [data-rewards-tier-list-item="2"]').forEach(el => el.classList.add('active'));
          document.querySelectorAll('[data-rewards-perks-tier-display]').forEach(el => {
            const tiers = el.getAttribute('data-rewards-perks-tier-display');
            if (tiers.includes('front-row')) el.classList.add('active')
          });
          document.querySelectorAll('[data-rewards-tier-list-message="2"]').forEach(el => el.innerHTML = strings.currentTier);
          break;
        case swellTiers[2].id:
          currentTierIndex = 3;
          nextTierIndex = 4;
          document.querySelectorAll('[data-rewards-tier-list-item="1"], [data-rewards-tier-list-item="2"], [data-rewards-tier-list-item="3"]').forEach(el => el.classList.add('active'));
          document.querySelectorAll('[data-rewards-perks-tier-display]').forEach(el => {
            const tiers = el.getAttribute('data-rewards-perks-tier-display');
            if (tiers.includes('vip')) el.classList.add('active')
          });
          document.querySelectorAll('[data-rewards-tier-list-message="3"]').forEach(el => el.innerHTML = strings.currentTier);
          break;
        case swellTiers[3].id:
          currentTierIndex = 4;
          nextTierIndex = false;
          document.querySelectorAll('[data-rewards-tier-list-item="1"], [data-rewards-tier-list-item="2"], [data-rewards-tier-list-item="3"], [data-rewards-tier-list-item="4"]').forEach(el => el.classList.add('active'));
          document.querySelectorAll('[data-rewards-perks-tier-display]').forEach(el => {
            const tiers = el.getAttribute('data-rewards-perks-tier-display');
            if (tiers.includes('backstage-pass')) el.classList.add('active')
          });
          document.querySelectorAll('[data-rewards-tier-list-message="4"]').forEach(el => el.innerHTML = strings.currentTier);
          break;
        default:
        // document.querySelectorAll('.swell-welcome__status').forEach(el => el.remove());
      }

      let progressData = {
        currentPoints: customerInfo.vipTierStats.pointsEarned,
        minPoints: 0,
        maxPoints: 0,
        currentTier: currentTierIndex,
        nextTier: nextTierIndex
      };

      if (currentTierIndex) {
        progressData.minPoints = swellTiers[currentTierIndex - 1].swellrequiredPointsEarned;
      }

      if (nextTierIndex) {
        progressData.maxPoints = swellTiers[nextTierIndex - 1].swellrequiredPointsEarned;
      }

      setTimeout(() => {
        this.updateProgressMeter(progressData);
      }, 1000);

      // let resizeTimer = null;
      // window.addEventListener('resize', () => {
      //   clearTimeout(resizeTimer);
      //   resizeTimer = setTimeout(() => {
      //     self.updateProgressMeter(progressData);
      //   }, 250);
      // });
    } catch (error) {
      document.querySelectorAll('.swell-welcome__status').forEach(el => el.remove());
      console.log('Unable to update tier progress.');
    }

    let replacements = this.recursiveDash(customerInfo);
    console.log('Swell Fields', replacements);
    console.log('Swell Customer Info', customerInfo);
    let swellProperties = Object.keys(replacements);

    document.querySelectorAll('[data-swell-field]').forEach(element => {
      const field = element.getAttribute('data-swell-field');
      if (swellProperties.includes(field)) {
        const value = replacements[field];
        element.innerText = (field === 'vipTier.name' || field === 'nextTier.name') ? (tierNames[value] || value) : value;
        element.classList.add('swell-field');
        element.classList.remove('swell-loading');
      }

      // User has achieved final tier status
      if (element.hasAttribute("data-progress-title") && !swellProperties.includes('nextTier.name')) {
        const earnMessageContainer = document.querySelector('.rewards-member__earn');
        const currentTier = document.querySelector('[data-current-tier]');
        const progressTitle = document.querySelector('[data-progress-title]');
        const message = strings.finalTierMessage;
        if (earnMessageContainer) earnMessageContainer.innerHTML = message;
        if (element) element.classList.add('rewards-member__final-tier');
        if (currentTier) currentTier.textContent = strings.tiers.backstagePass
        if (progressTitle) progressTitle.textContent = strings.tiers.vip
      }
    });

    // Backstage Pass member with less than 2500 points
    if (customerInfo?.vipTier?.name == 'Backstage Pass' && customerInfo?.vipTier?.vipTierExpirationDate && customerInfo?.vipTierStats?.pointsEarned < 2500) {
      const earnMessageContainer = document.querySelector('.rewards-member__earn');
      const expiration = customerInfo?.vipTier?.vipTierExpirationDate ? formatDate(customerInfo.vipTier.vipTierExpirationDate) : null;
      const points = 2500 - customerInfo.vipTierStats.pointsEarned;
      const message = strings.maintainTier.replace('[points]', points).replace('[date]', expiration);
      if (earnMessageContainer && expiration) earnMessageContainer.innerHTML = message;
    }

    if (customerInfo?.vipTier?.name == 'Backstage Pass') {
      const progressTitle = document.querySelector('[data-progress-title]');
      if (progressTitle) progressTitle.textContent = strings.tiers.vip;
    }

    // Backstage custom progress bar
    const progress = document.querySelector('.rewards-member__progress-bar-percentage');
    const isAfterToday = customerInfo?.vipTier?.vipTierExpirationDate ? moment(customerInfo.vipTier.vipTierExpirationDate).isAfter(moment(), 'day') : false;
    if (customerInfo?.vipTier?.name == 'Backstage Pass' && isAfterToday && progress) {
      progress.classList.add('rewards-member__progress-bar-percentage--backstage-pass');
    }

    document.querySelectorAll('[data-swell-if-field]').forEach(element => {
      let field = element.getAttribute('data-swell-if-field');
      let match = false;
      if (element.hasAttribute('data-swell-if-value-in')) {
        let values = JSON.parse(element.getAttribute('data-swell-if-value-in'));
        match = values.includes(replacements[field]);
      } else {
        match = replacements[field] == element.getAttribute('data-swell-if-value');
      }

      if (element.hasAttribute('data-swell-if-else')) {
        match = !match;
      }

      if (match) {
        element.classList.add('swell-field');
        element.classList.remove('swell-loading');
      } else {
        element.style.display = 'none';
        element.classList.add('swell-hidden');
        element.classList.remove('swell-loading');
      }
    });

    document.querySelectorAll('[data-swell-hide]').forEach(element => {
      if (!swellProperties.includes(element.getAttribute('data-swell-hide'))) {
        element.style.display = 'none';
        element.classList.add('swell-hidden');
        element.classList.remove('swell-loading');
      }
    });

    document.querySelectorAll('.swell-loading').forEach(element => element.classList.remove('swell-loading'));

    document.documentElement.classList.add('swell--loaded');
  }

  updateProgressMeter(data) {
    const progressbar = document.querySelector('[data-rewards-member-progress]');
    if (data.currentPoints >= 2500) {
      const percentage = 100;
      progressbar.setAttribute('aria-valuemax', data.maxPoints);
      progressbar.setAttribute('aria-valuenow', data.currentPoints);
      progressbar.style.width = `${percentage}%`;
    } else if (data.currentPoints <= data.maxPoints) {
      const percentage = (data.currentPoints / data.maxPoints) * 100;
      progressbar.setAttribute('aria-valuemax', data.maxPoints);
      progressbar.setAttribute('aria-valuenow', data.currentPoints);
      progressbar.style.width = `${percentage}%`;
    } else if (data.currentTier === 4) {
      const percentage = (data.currentPoints / 2500) * 100;
      progressbar.setAttribute('aria-valuemax', data.maxPoints);
      progressbar.setAttribute('aria-valuenow', data.currentPoints);
      progressbar.style.width = `${percentage}%`;
    }
  }

  recursiveDash(obj) {
    let newobj = {};
    let recurse = (obj, current) => {
      for (const prop in obj) {
        const key = current ? `${current}.${prop}` : prop;
        if (obj[prop] && typeof obj[prop] === "object") {
          recurse(obj[prop], key);
        } else {
          newobj[key] = obj[prop];
        }
      }
    };
    recurse(obj);
    return newobj;
  }
}

new Rewards();

class RewardTiers {
  constructor() {
    this.init();
  }

  init() {
    const boundCallback = this.buildTierLevels.bind(this);
    swellLoaded(boundCallback);
  }

  buildTierLevels() {
    let swellTiers = window.swellAPI.getVipTiers();
    let tierRanges = swellTiers.map(tier => ({
      id: tier.id,
      name: tier.name,
      lower: tier.swellrequiredPointsEarned,
      upper: '+'
    }));

    tierRanges.sort((a, b) => a.lower - b.lower);

    for (let i = 0; i < tierRanges.length - 1; i++) {
      tierRanges[i].upper = `-${tierRanges[i + 1].lower - 1}`;
    }

    tierRanges.forEach(tier => {
      let tierElement = document.querySelector(`[data-tier-id="${tier.id}"]`);
      if (tierElement) {
        let tierRange = tierElement.querySelector('.points-item');
        if (tierRange) {
          tierRange.textContent = `${tier.lower}${tier.upper}`;
        }

        let tierName = tierElement.querySelector('.name-item');
        if (tierName) {
          tierName.textContent = tier.name;
        }
      }
    });
  }
}

new RewardTiers();
